import React from "react";

const Footer = () => {
  return (
    <footer className="text-center p-5 dark:bg-black dark:text-white">
      <span className="font-semibold">Ashlyn Joshy &copy; 2024</span>
    </footer>
  );
};

export default Footer;
